exports = module.exports = require("./node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.loader[data-v-1b801586] {\n  text-align: center;\n  padding: 8px 12px;\n}\n.loader > .message[data-v-1b801586] {\n  font-weight: 800;\n  text-transform: uppercase;\n  font-size: 12px;\n}\n", ""]);

// exports
